import { IInitialState } from 'store/models';
import { respondentDataSelector } from './respondentDataSelector';

export function surveyTypeSelector(state: IInitialState) {
	return respondentDataSelector(state)?.chatBot;
}

export function surveyLanguageSelector(state: IInitialState) {
	return respondentDataSelector(state)?.t9n;
}
